import React from 'react'
import { FieldArray, useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import { EMPTY_TRANSLATIONS } from './form'
import styles from './CustomFieldsForm.module.css'
import TranslationsForm from 'components/CustomFields/CustomFieldsForm/TranslationsForm'
import { PrimaryButton } from 'components/Shared/PrimaryButton'
import { ReactComponent as AddIcon } from 'assets/icons/add-red.svg'
import IconButton from '@material-ui/core/IconButton'
import { ReactComponent as RemoveIcon } from 'assets/icons/trash.svg'

export default function SelectOptionsFieldArray () {
  const { values } = useFormikContext()
  const { t } = useTranslation()

  const addNewSelectOption = (event, arrayHelpers) => {
    arrayHelpers.push({ translations: { ...EMPTY_TRANSLATIONS }, isDefault: false })
    event.preventDefault()
  }

  return <FieldArray
    name={'selectOptions'}
    render={arrayHelpers => (<>
      {values.selectOptions?.map((option, index) => <div key={index}>
          <SelectFieldLabel
            label={t('customField.form.selectOptions.title', { index: index + 1 })}
            remove={{
              show: !option.isDefault,
              onClick: () => arrayHelpers.remove(index)
            }}/>
          <TranslationsForm label={'customField.form.selectOptions.translations.name'}
                            fieldName={`selectOptions[${index}].translations`}
                            warning={{
                              show: option.isDefault,
                              label: 'customField.form.selectOptions.translations.isDefault'
                            }}/>
        </div>
      )}
      <PrimaryButton
        type="button"
        label={t('customField.form.selectOptions.addButton')}
        onClick={event => addNewSelectOption(event, arrayHelpers)}
        icon={<AddIcon/>}/>
    </>)}
  />
}

function SelectFieldLabel ({ label, remove }) {
  const { t } = useTranslation()

  return <div className={styles.labelContainer}>
    <div className={styles.label}>{t(label)}</div>
    {remove.show &&
    <IconButton
      onClick={remove.onClick}>
      <RemoveIcon/>
    </IconButton>
    }
  </div>
}
